import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	CardDescription,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock, CalendarClock, Mail } from "lucide-react";
import { routes } from "@/app/routes/paths";

export const RegistrationClosedPage = ({ period }: { period: string }) => {
	return (
		<Card className="w-full text-center border-none light:bg-transparent shadow-transparent">
			<CardHeader className="text-center space-y-4 pt-10">
				<div className="flex justify-center">
					<div className="rounded-full bg-zinc-800 p-4">
						<Lock className="h-10 w-10 text-yellow-500" />
					</div>
				</div>

				<div className="relative mx-auto h-100 w-100">
					<img
						src="/assets/images/registration-closed.png"
						alt="Registration Closed"
						className="object-cover"
					/>
				</div>
				<CardTitle className="text-2xl font-bold dark:text-white">Registration Closed</CardTitle>

				<CardDescription className="text-[18px] text-gray-600">
					The annual resident registration for the
					<span className="font-bold"> {period} </span>
					has officially closed.
				</CardDescription>
			</CardHeader>

			<CardContent className="space-y-6 pb-10 text-center">
				<div className="space-y-3 text-[16px]">
					<div className="flex items-center justify-center gap-2">
						<CalendarClock className="h-4 w-4" />
						<span>Registration period has ended</span>
					</div>

					<div className="flex items-center justify-center gap-2">
						<Mail className="h-4 w-4" />
						<span>Contact the IT department on WhatsApp number <a href="tel:0503528510">0503528510</a> or email <a href="mailto:ict@gcps.edu.gh">ict@gcps.edu.gh</a> for assistance</span>
					</div>
				</div>

				<Button
					variant="default"
					className="mt-10"
					onClick={() => window.location.href = routes.BASE_APP_URL}
				>
					Go to Dashboard
				</Button>
			</CardContent>
		</Card>
	);
};
